import React from 'react';
import { SDRPeriodColumn } from './SDRPeriodColumn';
import { useSDRDashboardMetrics } from '@/hooks/useSDRDashboardMetrics';
import { Loader2 } from 'lucide-react';
import { format } from 'date-fns';
import divusLogoWhite from '@/assets/divus-logo-white.png';

export const SDRDashboardTV: React.FC = () => {
  const { todayMetrics, weekMetrics, monthMetrics, loading, lastUpdate } = useSDRDashboardMetrics();

  if (loading) {
    return (
      <div className="flex-1 w-full flex items-center justify-center bg-gradient-to-br from-blue-500 via-blue-600 to-blue-700">
        <div className="text-center">
          <Loader2 className="w-16 h-16 animate-spin text-white mx-auto mb-4" />
          <p className="text-white text-2xl">Loading SDR Dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 w-full bg-gradient-to-br from-blue-500 via-blue-600 to-blue-700 p-6 2xl:p-12 overflow-auto">
      {/* Header */}
      <div className="text-center mb-8 2xl:mb-12">
        <div className="flex items-center justify-center mb-4">
          <img src={divusLogoWhite} alt="Divus Legal Group" className="h-12 2xl:h-20 w-auto" />
        </div>
        <h1 className="text-5xl 2xl:text-7xl font-bold text-white mb-2">SDR Dashboard</h1>
        <div className="flex items-center justify-center gap-4 text-white/80 text-sm 2xl:text-xl">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 2xl:w-3 2xl:h-3 bg-green-400 rounded-full animate-pulse" />
            <span>Auto-updating every 30s</span>
          </div>
          <span>•</span>
          <span>Last update: {format(lastUpdate, 'HH:mm:ss')}</span>
        </div>
      </div>

      {/* 3 Column Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 2xl:gap-10 w-full px-2 2xl:px-8">
        <SDRPeriodColumn title="Today" metrics={todayMetrics} />
        <SDRPeriodColumn title="This Week" metrics={weekMetrics} />
        <SDRPeriodColumn title="This Month" metrics={monthMetrics} />
      </div>

      {/* Footer */}
      <div className="text-center mt-8 2xl:mt-12 text-white/60 text-sm 2xl:text-lg">
        Powered by Divus CRM
      </div>
    </div>
  );
};
